<template>
    <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="#009432"
        dark
    >
        <v-app-bar-nav-icon @click.stop="toggleSidebar"></v-app-bar-nav-icon>
        <v-toolbar-title
            style="width: 300px"
            class="ml-0"
        >
            <!-- <span class="hidden-sm-and-down">Google Contacts</span> -->
            <v-toolbar-title class="mr-12 align-center">
                <!-- <span class="title">Youtube</span> -->
                <v-img id="logo" src="@/assets/VERTEBRA.svg" />
            </v-toolbar-title>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <!-- <v-menu offset-y left>
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                    <v-badge
                        color="error"
                        left
                        overlap
                        class="align-self-center"
                        >
                        <template v-slot:badge>
                            <span>5</span>
                        </template>
                        <v-icon>mdi-bell</v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <v-list max-height="450">
                <v-subheader>Notficaciones</v-subheader>
                <v-list-item link class="new-notification">
                    <v-list-item-content>
                        <v-list-item-text>
                            Nuevo reporte
                        </v-list-item-text>
                        <v-list-item-subtitle>Se agregó nuevo reporte a su cuenta</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-text>
                            Nuevo reporte
                        </v-list-item-text>
                        <v-list-item-subtitle>Se agregó nuevo reporte a su cuenta</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-text>
                            Nuevo reporte
                        </v-list-item-text>
                        <v-list-item-subtitle>Se agregó nuevo reporte a su cuenta</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-text>
                            Nuevo reporte
                        </v-list-item-text>
                        <v-list-item-subtitle>Se agregó nuevo reporte a su cuenta</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-text>
                            Nuevo reporte
                        </v-list-item-text>
                        <v-list-item-subtitle>Se agregó nuevo reporte a su cuenta</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-text>
                            Nuevo reporte
                        </v-list-item-text>
                        <v-list-item-subtitle>Se agregó nuevo reporte a su cuenta</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-text>
                            Nuevo reporte
                        </v-list-item-text>
                        <v-list-item-subtitle>Se agregó nuevo reporte a su cuenta</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-text>
                            Nuevo reporte
                        </v-list-item-text>
                        <v-list-item-subtitle>Se agregó nuevo reporte a su cuenta</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu> -->
        <v-menu offset-y right>
            <template v-slot:activator="{ on }">

                <v-btn
                    icon
                    large
                    v-on="on"
                >
                    <v-avatar
                    size="32px"
                    item
                    >
                    <v-img
                        src="https://www.logolynx.com/images/logolynx/b4/b4ef8b89b08d503b37f526bca624c19a.jpeg"
                        alt="Vuetify"
                    >
                    </v-img>
                    </v-avatar>
                    
                </v-btn>
            </template>
            <v-card class="mr-auto text-center" width="300">
                
                <v-card-text>
                    <v-avatar size="100" link @click="dialog = true">
                        <v-img src="https://www.logolynx.com/images/logolynx/b4/b4ef8b89b08d503b37f526bca624c19a.jpeg" />
                    </v-avatar>
                    <v-row class="m-0 p-0">
                        <v-col>
                            <v-chip
                            color="primary"
                            label
                            >
                                <!-- <v-icon left>mdi-account-circle-outline</v-icon> -->
                                <small v-if="!auth.isVertebra()">{{ auth.getUser().name }} - ({{ auth.getUser().rol }})</small>
                                <small v-if="auth.isVertebra()">{{ auth.getUser().name }}</small>
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-list dense nav class="text-left">
                        <v-list-item link to="/smartchronos/mi-perfil">
                            <v-list-item-icon>
                                <v-icon>person</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Mi perfil</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <!-- <v-list-item link v-if="auth.isVertebra() && auth.getProject()" @click="changeProject">
                            <v-list-item-icon>
                                <v-icon>cached</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Cambiar proyecto</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item> -->
                        <v-list-item link @click.stop="logout">
                            <v-list-item-icon>
                                <v-icon>logout</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Salir</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-menu>

        <v-dialog
        v-model="dialog"
        max-width="290"
        >
            <v-card>
                <v-card-title class="headline">Cambiar imagen</v-card-title>
                <form @submit.prevent="changeImage" enctype="multipart/form-data">
                    <v-card-text class="text-center">
                                        
                        <v-avatar size="100" link @click="dialog = true">
                            <v-img :src="$getImage(null, true)" />
                        </v-avatar>
                        <v-divider class="my-5"></v-divider>
                        <v-file-input
                            label="Imagen"
                            filled
                            prepend-icon="mdi-camera"
                            @change="onFileSelected"
                        ></v-file-input>

                    </v-card-text>

                    <v-card-actions>
                    <div class="flex-grow-1"></div>

                    <v-btn
                        color="green darken-1"
                        text
                        type="submit"
                    >
                        Subir
                    </v-btn>
                    </v-card-actions>

                </form>
            </v-card>
        </v-dialog>        
    </v-app-bar>
</template>
<script>
import Vue from 'vue'
import { Auth } from '../classes/Auth'
import { apiv1 } from '../libs/apiv1';


const auth = new Auth;

export default Vue.extend({
    name: 'Navbar',
    data: () => ({
        auth: auth,
        dialog: false,
        imagen: null,
        file: null
    }),
    props: ["drawer"],
    mounted(){
        this.$getImage(null, true);
    },
    methods: {
        logout: async function (){
            await apiv1.post(`${process.env.VUE_APP_BACKEND}/logout`);
            auth.logout()
            this.$router.push("/")
        },
        toggleSidebar: function(){
            // console.log(this.drawer)
            this.$emit('toggle', !this.drawer);
        },
        // getImage: function(){
        //     const auth = new Auth;
        //     if(auth.getProject()){
        //         return `${process.env.VUE_APP_BACKEND}/avatars/` + auth.getProject().image;
        //     }
        //     return 'https://pngimage.net/wp-content/uploads/2018/06/no-avatar-png-8.png';
        // },
        changeProject: function(){
            localStorage.removeItem('AUTH_PROJECT');
            this.$router.push('/choose-project')
        },
        onFileSelected: function(e){
            this.file = e;
        },
        changeImage: function(){
            const fd = new FormData;
            fd.append('image', this.file)
        }
    }
})
</script>
<style lang="sass" scoped>
    #logo
        width: 180px

    .new-notification
        background: rgba(blue, .1)
</style>